import Fader from './inc/Fader';

const sliderElem = document.querySelector('.slider');
if(document.body.contains(sliderElem)) {
	new Fader(sliderElem, sliderElem.querySelectorAll('.slider__item'), 7000);
}